import { Grid } from '@mui/material';

import { RoutalLoader } from '@nx-smartmonkey/ui';
import { Text } from '../../../react-components/Text';

export const RegisterLoader = () => {
  return (
    <Grid container flexDirection="column" gap="24px" flex="1">
      <Text
        intlId="drivers.register.registering_loader.title"
        variant="h6"
        style={{ marginBottom: `24px`, textAlign: `center` }}
      />

      <Grid display={`flex`} flex="1" justifyContent={`center`}>
        <RoutalLoader />
      </Grid>
    </Grid>
  );
};
